






























import { Component, Vue, Prop } from 'vue-property-decorator'
// @ts-ignore
import LangSwitcher from '@/components/common/LangSwitcher.vue'

  @Component({
    components: {
      LangSwitcher
    }
  })
export default class PageWithHeaderFooter extends Vue {
    @Prop() readonly headerTitle!: string
}
